import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  FilterAccordionHeader,
  KeyValue,
  MultiColumnList,
  Row,
  Col,
} from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import displayMethodsConst from '../../../../../constants/DisplayMethods';

function ReportDisplayMethods({ selectedReport }) {
  const [filterToggle, setFilterToggle] = useState(true);
  const intl = useIntl();

  const visualization = selectedReport?.visualization || {};
  const rawMethods = visualization.displayMethods || [];
  const defaultMethod = visualization.defaultDisplayMethod;

  // Normalize to array of strings
  const methodNames = rawMethods.map(m => (typeof m === 'object' ? m.name || m.value : m));

  const contentData = methodNames.map(name => ({ name }));

  const getMethodLabel = (name) => {
    const found = displayMethodsConst.find(
      m => m.value === name || m.value?.toLowerCase() === name?.toLowerCase()
    );
    if (found?.translationKey) return intl.formatMessage(found.translationKey);
    return name || '';
  };

  const formatter = {
    label: (item) => getMethodLabel(item.name),
    isDefault: (item) => {
      const isDefault = defaultMethod &&
        (item.name === defaultMethod ||
         item.name?.toLowerCase() === defaultMethod?.toLowerCase());
      return isDefault ? (
        <FormattedMessage id="ui-reports.reportDetails.displayMethods.columns.isDefault" defaultMessage="✓ Default" />
      ) : null;
    },
  };

  if (!contentData.length && !defaultMethod) return null;

  return (
    <Accordion
      id="report-details-display-methods-accordion"
      label={<FormattedMessage id="ui-reports.reportDetails.displayMethods.accordion.header" defaultMessage="Display methods" />}
      onToggle={() => setFilterToggle(!filterToggle)}
      open={filterToggle}
      separator
      header={FilterAccordionHeader}
    >
      {defaultMethod && (
        <Row>
          <Col xs={12}>
            <KeyValue
              label={<FormattedMessage id="ui-reports.visualization.defaultDisplayMethod" defaultMessage="Default display method" />}
              value={getMethodLabel(defaultMethod)}
            />
          </Col>
        </Row>
      )}

      {contentData.length > 0 && (
        <MultiColumnList
          id="report-details-display-methods-mcl"
          interactive={false}
          visibleColumns={['label', 'isDefault']}
          contentData={contentData}
          columnMapping={{
            label: <FormattedMessage id="ui-reports.reportDetails.displayMethods.columns.name" defaultMessage="Method" />,
            isDefault: <FormattedMessage id="ui-reports.reportDetails.displayMethods.columns.isDefault" defaultMessage="Default" />,
          }}
          columnWidths={{ label: '70%', isDefault: '30%' }}
          formatter={formatter}
        />
      )}
    </Accordion>
  );
}

ReportDisplayMethods.propTypes = {
  selectedReport: PropTypes.object,
};

export default ReportDisplayMethods;
